import React from "react";
import styled from "styled-components";
import { IPageSectionResponse } from "models/response/page-section-response";
import { SectionImage, SectionTitle } from "../custom-page.styles";

const ItemListContainer = styled.div`
  margin-bottom: 30px;
`;

const ItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

const ItemCard = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  ${props => props.onClick && `
    cursor: pointer;
  `}
`;

const ItemImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 15px;
`;

const ItemTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

const ItemSubtitle = styled.h4`
  font-size: 16px;
  font-weight: 500;
  color: #666;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ItemDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

interface ItemListSectionProps {
    section: IPageSectionResponse;
}

export const ItemListSection: React.FC<ItemListSectionProps> = ({ section }) => {
    const handleItemClick = (url?: string) => {
        if (url) {
            window.open(url, '_blank');
        }
    };

    if (!section.items || section.items.length === 0) {
        return null;
    }

    const sortedItems = [...section.items].sort((a, b) => a.order - b.order);

    return (
        <ItemListContainer>
            {section.title && <SectionTitle>{section.title}</SectionTitle>}
            {section.imageUrl && <SectionImage src={section.imageUrl} alt={section.title || ''} />}
            <ItemsGrid>
                {sortedItems.map((item) => (
                    <ItemCard
                        key={item.id}
                        onClick={item.url ? () => handleItemClick(item.url) : undefined}
                    >
                        {item.imageUrl && (
                            <ItemImage src={item.imageUrl} alt={item.title || ''} />
                        )}
                        {item.title && <ItemTitle>{item.title}</ItemTitle>}
                        {item.subtitle && <ItemSubtitle>{item.subtitle}</ItemSubtitle>}
                        {item.description && <ItemDescription>{item.description}</ItemDescription>}
                    </ItemCard>
                ))}
            </ItemsGrid>
        </ItemListContainer>
    );
};
